<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" loader="bars" />

    <div
      id="createsession"
      class="modal fade"
      :class="{ show: show }"
      style="background: rgba(0, 0, 0, 0.5)"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" v-click-outside="onCancel">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between mb-3">
              <h5 class="px-2 mb-0">{{ $t("create_session") }}</h5>
              <p class="cursor-pointer px-2" @click="onCancel">
                <img src="../../assets/images/Vector (1).png" />
              </p>
            </div>

            <form class="p-2" @submit.prevent="create">
              <!-- Name -->
              <div class="form-group">
                <label>{{ $t("name") }}</label>
                <input v-model="name" class="form-control" required />
              </div>

              <!-- Dates -->
              <div class="form-group">
                <label>{{ $t("start_end_date") }}</label>
                <div class="d-flex" style="gap: 0.5rem">
                  <input
                    type="date"
                    v-model="startDate"
                    class="form-control"
                    required
                    :min="new Date().toISOString().slice(0, 10)"
                  />
                  <input
                    type="date"
                    v-model="endDate"
                    class="form-control"
                    required
                    :min="startDate"
                  />
                </div>
              </div>

              <!-- Devices -->
              <div class="form-group">
                <ComboBox
                  :data="sortedDevices"
                  prefix="devices"
                  :label="$t('add_device')"
                  :isItemChecked="isDeviceChecked"
                  @checkClick="toggleDevice"
                  @doSearch="doSearch"
                  :isSelectAll="
                    devices.length > 0 && devices.length === sortedDevices.length
                  "
                  :selectAll="selectAllDevices"
                  :deSelectAll="deSelectAllDevices"
                />
                <div
                  v-if="showValidation && !devices.length"
                  class="text-danger mt-1"
                >
                  {{ $t("select_one_device") }}
                </div>
              </div>

              <div class="d-flex justify-content-end">
                <button class="btn btn-primary">{{ $t("create") }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import vClickOutside from "v-click-outside";
import { mapActions } from "vuex";
import ComboBox from "../../components/ComboBox.vue";

export default {
  name: "CreateSession",
  props: { show: Boolean },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      name: "",
      startDate: "",
      endDate: "",
      devices: [],
      allDevices: [],
      sortedDevices: [],
      showValidation: false,
    };
  },
  components: { Loading, ComboBox },
  directives: { clickOutside: vClickOutside.directive },
  methods: {
    ...mapActions(["createSession"]),
    onCancel() {
      this.$emit("closeCreateSessionModal");
    },
    async create() {
      this.isLoading = true;
      if (!this.devices.length) {
        this.showValidation = true;
        this.isLoading = false;
        return;
      }
      this.showValidation = false;
      try {
        await this.createSession({
          name: this.name,
          devices: this.devices,
          startDate: this.startDate,
          endDate: this.endDate,
        });
        this.$emit("showSuccessPopup");
        this.onCancel();
      } finally {
        this.isLoading = false;
      }
    },
    isDeviceChecked(d) {
      return this.devices.includes(d.id);
    },
    toggleDevice(d) {
      const i = this.devices.indexOf(d.id);
      i === -1 ? this.devices.push(d.id) : this.devices.splice(i, 1);
    },
    doSearch({ target: { value } }) {
      const q = value.toLowerCase();
      this.sortedDevices = this.allDevices.filter(
        (d) =>
          d.name.toLowerCase().includes(q) || d.imei.toLowerCase().includes(q)
      );
    },
    selectAllDevices() {
      this.devices = this.sortedDevices.map((d) => d.id);
    },
    deSelectAllDevices() {
      this.devices = [];
    },
  },
  mounted() {
    this.allDevices = this.$store.getters.devices.map(({ id, imei, settings }) => ({
      id,
      imei,
      name: settings.name,
      label: `${settings.name} (${imei})`,
    }));
    this.sortedDevices = this.allDevices;
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 500px !important;
}
</style>

<i18n>
{
  "en": {
    "create_session":"Create Session",
    "name":"Name",
    "start_end_date":"Start Date & End Date",
    "add_device":"Add Device",
    "create":"Create",
    "select_one_device": "Please select at least one device"
  }
}
</i18n>
